import Stats from './stats'
import Detail from './detail'
import __data from './mock'

export default {
  props:['pathId'],
  data(){
    return {
      data:{}
    }
  },
  created(){
    if(this.pathId){
      this.query()
    }
  },
  methods:{
    query(){
      //logisticsPath
      this.$request.logisticsPath(this.pathId).then(resp => {
        resp.data.route = resp.data.navigates.reduce((t,c) => t.concat(c.seqPointList) , [])
        this.data = resp.data
      })
    }
  },
  render(){
    return <div style="width:100%;height:100%;">
      <Detail data={this.data} />
      <Stats data={this.data} />
    </div>
  }
}